<svg
  #svg
  attr.viewBox="0 0 {{ diameter }} {{ diameter }}"
  class="svg-element"
></svg>
